import { useState } from 'react';
import { Badge } from './ui/badge';
import { ExternalLink, Unlock } from 'lucide-react';

const NewsCard = ({ article, isClarityPick = false, isOutsideBubble = false, onClick }) => {
  const [imageError, setImageError] = useState(false);
  
  const fallbackImage = 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=800&q=80';
  const imageUrl = (imageError || !article.image_url) ? fallbackImage : article.image_url;

  return (
    <div
      className="relative h-80 sm:h-96 rounded-lg sm:rounded-xl overflow-hidden cursor-pointer group shadow-lg hover:shadow-2xl transition-all duration-300"
      onClick={onClick}
      data-testid="news-card"
    >
      {/* Image Fill */}
      <img
        src={imageUrl}
        alt={article.title}
        className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        onError={() => setImageError(true)}
      />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/50 to-transparent" />

      {/* Content - Lower Third */}
      <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 text-white">
        <div className="flex flex-wrap gap-1.5 mb-2 sm:mb-3">
          {isClarityPick && (
            <Badge className="bg-blue-600 hover:bg-blue-700 text-white text-xs" data-testid="clarity-pick-badge">
              Clarity's Pick
            </Badge>
          )}
          {isOutsideBubble && (
            <Badge className="bg-purple-600 hover:bg-purple-700 text-white text-xs flex items-center gap-1" data-testid="outside-bubble-badge">
              <Unlock className="w-3 h-3" />
              Outside Your Bubble
            </Badge>
          )}
        </div>

        <h3 className="font-serif text-lg sm:text-xl lg:text-2xl font-semibold mb-1 sm:mb-2 line-clamp-3 leading-tight">
          {article.title}
        </h3>

        <div className="flex items-center justify-between text-xs sm:text-sm text-gray-300">
          <span className="font-medium">{article.source.name}</span>
          {article.pub_date && (
            <span className="hidden sm:inline">{new Date(article.pub_date).toLocaleDateString()}</span>
          )}
        </div>
      </div>

      {/* Hover overlay with external link icon - Desktop only */}
      <div className="absolute top-3 sm:top-4 right-3 sm:right-4 opacity-0 group-hover:opacity-100 transition-opacity hidden sm:block">
        <div className="bg-white/20 backdrop-blur-sm rounded-full p-2">
          <ExternalLink className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
        </div>
      </div>
    </div>
  );
};

export default NewsCard;
